import Card from '@mui/material/Card'
import { styled } from '@mui/material/styles'

export const StyledCard = styled(Card)({
  '&.MuiCard-root': {
    padding: 0,
  },
})

export const CardWrapper = styled('div')({
  display: 'flex',
  width: '100%',
})

export const CardInnerContent = styled('div')(({ theme }) => ({
  width: '100%',
  padding: theme.spacing(2),
  display: 'flex',
  alignItems: 'start',
  flexDirection: 'column',
}))
